
// Show .fixed after scrolling past .fv, hide when reaching .footer
(function() {
  var fv = document.querySelector('.fv');
  var fixed = document.querySelector('.fixed');
  var footer = document.querySelector('.footer');
  if (!fv || !fixed) return;

  function onScroll() {
    var fvBottom = fv.getBoundingClientRect().bottom;
    var footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    var windowHeight = window.innerHeight;

    if (fvBottom <= 500 && footerTop > windowHeight) {
      fixed.classList.add('is-show');
    } else {
      fixed.classList.remove('is-show');
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// Voice slider (SP only)
(function() {
  var slider = document.querySelector('.voice__items');
  var pagination = document.querySelector('.voice__pagination');
  if (!slider || !pagination) return;

  var items = slider.querySelectorAll('.voice__item');
  var count = items.length;

  // Create dots
  var dots = [];
  for (var i = 0; i < count; i++) {
    var dot = document.createElement('span');
    dot.className = 'voice__pagination-dot';
    if (i === 0) dot.classList.add('is-active');
    (function(index) {
      dot.addEventListener('click', function() {
        slider.scrollTo({ left: slider.clientWidth * index, behavior: 'smooth' });
      });
    })(i);
    pagination.appendChild(dot);
    dots.push(dot);
  }

  // Update active dot on scroll
  var ticking = false;
  slider.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(function() {
        var index = Math.round(slider.scrollLeft / slider.clientWidth);
        dots.forEach(function(d, i) {
          d.classList.toggle('is-active', i === index);
        });
        ticking = false;
      });
      ticking = true;
    }
  });
})();

document.querySelectorAll('.qa__q').forEach(function(q) {
  q.addEventListener('click', function() {
    var answer = this.closest('.qa__item').querySelector('.qa__a');

    this.classList.toggle('is-active');
    answer.classList.toggle('is-open');
  });
});


// Quiz form
document.addEventListener('DOMContentLoaded', function() {
  var steps = document.querySelectorAll('[data-step]');

  function showStep(stepNum) {
    steps.forEach(function(el) {
      el.hidden = el.dataset.step !== String(stepNum);
    });
    var formEl = document.querySelector('.form');
    if (formEl) {
      window.scrollTo({ top: formEl.offsetTop - 20, behavior: 'smooth' });
    }
  }

  // ラジオ選択で自動遷移（Steps 1〜4）
  document.querySelectorAll('[data-step]:not([data-step="5"]) .quiz__radio').forEach(function(radio) {
    radio.addEventListener('change', function() {
      var currentStep = radio.closest('[data-step]');
      var nextStep = parseInt(currentStep.dataset.step, 10) + 1;
      setTimeout(function() {
        showStep(nextStep);
      }, 300);
    });
  });

  // 送信ボタン（Step5）
  var submitBtn = document.querySelector('[data-submit]');
  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      var name  = document.getElementById('name').value.trim();
      var tel   = document.getElementById('tel').value.trim();
      var email = document.getElementById('email').value.trim();
      var q1 = (document.querySelector('input[name="q1"]:checked') || {}).value || '';
      var q2 = (document.querySelector('input[name="q2"]:checked') || {}).value || '';
      var q3 = (document.querySelector('input[name="q3"]:checked') || {}).value || '';
      var q4 = (document.querySelector('input[name="q4"]:checked') || {}).value || '';

      if (!name)  { alert('お名前を入力してください。'); return; }
      if (!tel)   { alert('電話番号を入力してください。'); return; }
      if (!/^0\d{9,10}$/.test(tel.replace(/-/g, ''))) {
        alert('電話番号を正しい形式で入力してください。\n例）09012345678 または 090-1234-5678');
        return;
      }
      if (!email) { alert('メールアドレスを入力してください。'); return; }

      var formData = new FormData();
      formData.append('name', name);
      formData.append('tel', tel);
      formData.append('email', email);
      formData.append('q1', q1);
      formData.append('q2', q2);
      formData.append('q3', q3);
      formData.append('q4', q4);

      submitBtn.disabled = true;

      fetch('./mail.php', { method: 'POST', body: formData })
        .then(function(res) { return res.json(); })
        .then(function(json) {
          if (json.status === 'success') {
            window.location.href = './thanks.html';
          } else {
            alert(json.message || '送信に失敗しました。');
            submitBtn.disabled = false;
          }
        })
        .catch(function() {
          alert('通信エラーが発生しました。');
          submitBtn.disabled = false;
        });
    });
  }
});
